// Same status vocabulary as DeliveryInfoCard's statusColors — kept in sync manually
// since that map isn't exported from the component.
//   Por entregar          — default, nothing has happened yet
//   En ruta                — driver is actively delivering this one right now;
//                            at most one per driver, highlighted separately
//   Entregado               — delivered in full
//   Parcialmente entregado — delivered, but not all products; counts as
//                            "delivered" for completion purposes, flagged in the UI
//   No entregado           — delivery failed
//   Reagendado             — delivery failed, but a new delivery was already created
export const DELIVERY_STATUS_COLORS = {
  "Por entregar": "red",
  "En ruta": "orange",
  Entregado: "green",
  "Parcialmente entregado": "gold",
  "No entregado": "gray",
  Reagendado: "blue",
};

export const PAYMENT_METHODS = ["Efectivo", "Transferencia", "Tarjeta"];

const { format: formatCLPValue } = new Intl.NumberFormat("es-CL", {
  style: "currency",
  currency: "CLP",
});

export const formatCLP = (value) => formatCLPValue(value || 0);

// Returns the delivery_info_array entry for a given order that matches routeDay,
// same lookup RouteStep1 uses to resolve "today's" driver for an order.
export const getRouteDayDelivery = (order, routeDay) =>
  order.delivery_info_array?.find((d) => d.delivery_date?.startsWith(routeDay));

// Groups orders by the driver assigned on routeDay. Orders with no driver_id,
// or the backend's "No asignado" sentinel (personnel id 0), are collected
// under the `null` key.
export const groupOrdersByDriver = (orders, routeDay) => {
  const groups = new Map();
  orders.forEach((order) => {
    const delivery = getRouteDayDelivery(order, routeDay);
    if (!delivery) return;
    const driverId = delivery.driver_id || null;
    if (!groups.has(driverId)) groups.set(driverId, []);
    groups.get(driverId).push(order);
  });
  return groups;
};

// Delivery-status counts for a set of orders, scoped to routeDay.
export const computeDeliveryCounts = (orders, routeDay) => {
  const counts = {
    total: 0,
    pending: 0,
    enRuta: 0,
    delivered: 0,
    partiallyDelivered: 0,
    notDelivered: 0,
    rescheduled: 0,
  };
  orders.forEach((order) => {
    const delivery = getRouteDayDelivery(order, routeDay);
    if (!delivery) return;
    counts.total += 1;
    switch (delivery.delivery_status) {
      case "En ruta":
        counts.enRuta += 1;
        break;
      case "Entregado":
        counts.delivered += 1;
        break;
      case "Parcialmente entregado":
        counts.partiallyDelivered += 1;
        break;
      case "No entregado":
        counts.notDelivered += 1;
        break;
      case "Reagendado":
        counts.rescheduled += 1;
        break;
      default:
        counts.pending += 1;
    }
  });
  return counts;
};

// Normalizes a driver-summary API response (`recaudacion` array) into a
// fixed { Efectivo, Transferencia, Tarjeta } map, defaulting missing methods to 0.
export const normalizeRecaudacion = (recaudacion = []) => {
  const byMethod = Object.fromEntries(PAYMENT_METHODS.map((m) => [m, 0]));
  recaudacion.forEach((entry) => {
    if (entry.payment_method in byMethod) {
      byMethod[entry.payment_method] = entry.total;
    }
  });
  return byMethod;
};
